import axios from 'axios';
import store from '../store';
import sha256 from 'sha.js'; // SHA-256 hashing module

// Create Axios instance with base configuration
const api = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
  timeout: 10000, // 10-second request timeout
});

// Build headers, including Authorization token
const buildHeaders = () => {
  const authHash = getAuthHash(); // Generate the auth hash
  return {
    headers: {
      Authorization: `Bearer ${JSON.stringify(authHash)}`, // Attach the hash in Authorization header
    },
  };
};

// Generate authentication hash from Vuex store's key and secret
const getAuthHash = () => {
  const key = store.state.auth.key;
  const secret = store.state.auth.secret;

  if (!key || !secret) {
    return null;
  }

  const nonce = require('nonce')();
  const timestamp = '1' + nonce();
  const signature = key + secret + timestamp;
  const hash = doHash(signature);

  return {
    key: key,
    timestamp: timestamp,
    hash: hash,
  };
};

// Helper function to hash a string using SHA-256
const doHash = req => {
  return sha256('sha256').update(req).digest('hex');
};

// Request interceptor: Attach Authorization token to each request
api.interceptors.request.use(config => {
  const headers = buildHeaders();
  return { ...config, ...headers };
}, error => {
  return Promise.reject(error);
});

// Response interceptor: Handle errors globally
api.interceptors.response.use(
  response => response.data.data,
  error => {
    if (error.response) {
      const errorMessage = error.response.data? error.response.data.message :'API Error. Please try again.';
      return Promise.reject(new Error(errorMessage));
    }
    return Promise.reject(new Error('Network error. Please check your connection.'));
  }
);

// API wrapper for GET, POST, PUT, DELETE requests
const baseApi = {
  get(url, params = {}, config = {}) {
    return api.get(url, { ...config, params });
  },
  post(url, data = {}, config = {}) {
    return api.post(url, data, config);
  },
  put(url, data = {}, config = {}) {
    return api.put(url, data, config);
  },
  delete(url, config = {}) {
    return api.delete(url, config);
  }
};

export default baseApi;
